import React, { useState, useEffect } from 'react';
import { useToasts } from 'react-toast-notifications';
import { Row, Col, Button, Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronLeft, faEnvelope, faExclamationTriangle, faPhone, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Field, DeleteButton } from '@galop/component-library';
import Can from '../Shared/Can';
import { deleteInquiry } from './Inquiries';
import { globalErrorHandler } from '../../api/create-api';
import { FuzzyDate } from '../../Helpers/Helper';

export const ViewInquiry = (props) => {
    const { config, Close, Save, ReloadResources, resource } = props;
    const { addToast, removeToast } = useToasts();

    const deleteResource = () => {
        deleteInquiry(() => addToast(`Deleting ${config.capitalResourceName}`, { appearance: 'info', id: 'deleting-resource' }), resource.id, () => removeToast('deleting-resource', () => {
            if (Save) {
                Save({ ...resource, deleted: !resource.deleted });
            }

            if (ReloadResources) {
                ReloadResources();
            }

            Close();
        }), (error) => globalErrorHandler(error, addToast));
    };

    return (
        <div className="mb-2 d-flex flex-column h-100">
            <div className="mb-1">
                <Row>
                    <Col className="d-flex">
                        <div className="d-inline-block d-md-none">
                            <Button color="link" className="py-0" onClick={Close}><FontAwesomeIcon icon={faChevronLeft} /></Button>
                        </div>
                        <div className="flex-fill d-flex">
                            <span className="h3 text-dark pb-0 mb-0">{resource.propertyName}</span>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="flex-fill scrollable-list border-top border-bottom" style={{ overflowY: 'auto', overflowX: 'hidden' }}>
                {resource.submitted ?
                    <div className="text-end fst-italic me-1">
                        <small>{FuzzyDate(resource.submitted)}</small>
                    </div>
                    :
                    <Alert color="danger" className="mt-2" fade={false}>
                        <FontAwesomeIcon icon={faExclamationTriangle} /> An error occurred while attempting to send this email.
                    </Alert>
                }
                <Row className="my-2 my-sm-0">
                    <Col lg="6" xl="8">
                        <Row>
                            <Col xs="12">
                                <Field type="text" label="Name" field="name" value={resource.name} ReadOnly />
                            </Col>
                            <Col sm="8" md="12" xl="8">
                                <label className="form-label" htmlFor="phone">Email</label>
                                <div className="d-flex">
                                    <div className="flex-fill me-1">
                                        <Field type="text" label="Email" HideLabel field="email" value={resource.email} ReadOnly />
                                    </div>
                                    <div>
                                        <Button color="primary" outline tag="a" href={`mailto:${resource.email}`}><FontAwesomeIcon icon={faEnvelope} /></Button>
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <label className="form-label" htmlFor="phone">Phone</label>
                                <div className="d-flex">
                                    <div className="flex-fill me-1">
                                        <Field type="text" label="Phone" HideLabel field="phone" value={resource.phone} ReadOnly />
                                    </div>
                                    <div>
                                        <Button color="primary" outline tag="a" href={`tel:${resource.phone}`}><FontAwesomeIcon icon={faPhone} /></Button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <Field type="text" label="Topic" field="topic" value={resource.topic} ReadOnly />
                        <Field type="textarea" label="Details" field="details" value={resource.details} ReadOnly />
                    </Col>
                </Row>
            </div>
            <Row className="pt-1">
                <Can role={config.writeRole}
                    yes={() => <Col>
                        <DeleteButton color="danger" outline Close={deleteResource} ShowDropdown={true}>Delete</DeleteButton>
                    </Col>}
                />
                <Col className="text-end">
                    <Button color="light" className="border me-1" onClick={Close}>Close</Button>
                </Col>
            </Row>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/Inquiries/ViewInquiry.js